module.exports = __webpack_public_path__ + "img/SmartRemote_einfarbig_RGB.ef7c7b72.svg";